"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _Backdrop = _interopRequireDefault(require("@mui/material/Backdrop"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["invisible", "transitionDuration", "isInternal", "onClose", "active", "rootElementId", "directionOfset", "direction"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function isVisible(element) {
  if (element.getBBox) {
    var _element$getBBox = element.getBBox(),
      width = _element$getBBox.width,
      height = _element$getBBox.height;
    return width > 0 && height > 0;
  }
  return element.offsetWidth > 0 && element.offsetHeight > 0;
}
var dataCy = exports.dataCy = 'backdrop';
var _default = exports["default"] = function _default(_ref) {
  var _ref$invisible = _ref.invisible,
    invisible = _ref$invisible === void 0 ? false : _ref$invisible,
    duration = _ref.transitionDuration,
    _ref$isInternal = _ref.isInternal,
    isInternal = _ref$isInternal === void 0 ? function () {
      return false;
    } : _ref$isInternal,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {
      return false;
    } : _ref$onClose,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$rootElementId = _ref.rootElementId,
    rootElementId = _ref$rootElementId === void 0 ? 'root' : _ref$rootElementId,
    directionOfset = _ref.directionOfset,
    direction = _ref.direction,
    props = _objectWithoutProperties(_ref, _excluded);
  var onWindowClick = (0, _react.useCallback)(function (event) {
    if (!isInternal(event) && isVisible(event.target)) {
      onClose(event);
    }
  }, [isInternal, onClose]);

  //outside click behavior instead backdrop
  (0, _react.useEffect)(function () {
    if (invisible) {
      var applicationElement = window.document.getElementById(rootElementId);
      if (active) {
        applicationElement.addEventListener('click', onWindowClick, {
          capture: true
        });
        return function () {
          applicationElement.removeEventListener('click', onWindowClick, {
            capture: true
          });
        };
      } else {
        applicationElement.removeEventListener('click', onWindowClick, {
          capture: true
        });
      }
    }
  }, [invisible, active]);
  if (invisible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({
      "data-cy": dataCy,
      style: {
        display: 'none'
      }
    }, props));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Backdrop["default"], _objectSpread({
    sx: {
      right: function right() {
        return direction === 'left' ? "".concat(directionOfset ? directionOfset : 0) : '0';
      },
      left: function left() {
        return direction === 'right' ? "".concat(directionOfset ? directionOfset : 0) : '0';
      }
    },
    transitionDuration: duration,
    "data-cy": dataCy
  }, props));
};